import { isEmpty } from 'lodash';
import { TFooterComponent } from '../type';
import LanguageVersionSelector from 'cms/utilities/LanguageVersionSelector';
import ILanguageVersionList from 'cms/interfaces/ILanguageVersionList';
import { EView } from 'cms/enums/EView';
import SanitizeHTMLString from 'cms/utilities/SanitizeHTMLString';


function BottomBarLoader () {

    return (
        <></>
    )

}

function BottomBar ( props:TFooterComponent ) {
    console.log("BottomBar.rendered", props)

    const parentItem = props.payload?.find((item) => item.layouts?.filter((litem) => litem.layoutName === props.layoutName).length > 0);

    if ( parentItem && !isEmpty(parentItem) ) {

        const childItems = props.payload?.filter((item) => item.parentId === parentItem.id);

        const copyrightString = LanguageVersionSelector<ILanguageVersionList|null>({
            languageVersions: childItems?.[0]?.languageVersions,
            filters: [
                { view: EView.META_DATA, name: "copyrightString" }
            ],
            type: "find"
        });

        return (
            <div className="site-footer-three__bottom">
                <div className="container">
                    <div className="site-footer-three__bottom-inner tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
                        <p className="tw-flex tw-items-end tw-justify-center md:tw-justify-start site-footer-three__bottom-text ck-content md:tw-h-full !tw-mt-0 tw-mb-3 md:tw-mb-0" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(copyrightString?.value)}} />
                        <p className="tw-inline-flex tw-items-center tw-justify-center site-footer-three__bottom-text !tw-mt-0">
                            <a href="https://www.armadorteknoloji.com" className="tw-inline-flex tw-items-center tw-justify-center tw-flex-col tw-text-white hover:tw-text-black" title='Armador Yazılım ve Teknoloji A.Ş.'>
                                <img src="https://cdn.armadorteknoloji.com/armador-software-and-technology-inc-negative.webp" alt="Armador Yazılım ve Teknoloji A.Ş." title="Armador Yazılım ve Teknoloji A.Ş." className='tw-h-8 tw-pl-3' loading='lazy' width={512} height={100} />
                                Powered By ARMADOR Yazılım ve Teknoloji A.Ş.
                            </a>
                        </p>
                        <p></p>
                    </div>
                </div>
            </div>
        );

    }

    return <BottomBarLoader />;
    
    
}

export default BottomBar;
